import { useState, useRef, useEffect } from 'react';
import { SmartForm } from '../../components/formFields/Form';
import { TextField } from '../../components/formFields/TextField';
import { TextArea } from '../../components/formFields/textArea/TextArea.component';
import { api } from '../../data/api';
import { Spinner } from '../../components/spinner/Spinner.component';
import toast from 'react-hot-toast';



export const PedirAyuda = () => {

	const [loading, setLoading] = useState(false);
	const [emailSent, setEmailSent] = useState(false);
	const [mensaje, setMensaje] = useState('');
	const textAreaRef = useRef<HTMLTextAreaElement>(null);

	useEffect(() => {
		if (!loading && !emailSent && textAreaRef.current) {
			textAreaRef.current.focus();
		}
	}, [loading, emailSent]);

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setLoading(true);

		try {
			await api.post('/api/ayuda/medico', {
				mensaje: mensaje
			});
			setEmailSent(true);
		} catch (error) {
			console.error("### error", error);
			toast.error('Error al enviar el mensaje');
		} finally {
			setLoading(false);
		}
	}

	if (loading) return <Spinner />

	return (
		<SmartForm
			title={emailSent ? 'Mensaje Enviado' : 'Pedir Ayuda'}
			onSubmit={handleSubmit}
			confirmButtonLabel={emailSent ? undefined : 'Enviar'}
		>
			{emailSent ?
				<p>
					Gracias por tu mensaje. Nos pondremos en contacto contigo lo antes posible. Recibiras un correo de parte nuestra. Revisa la carpeta de Spam si no lo encuentras.
				</p>
			:
				<TextArea 
					ref={textAreaRef}
					value={mensaje} 
					onChange={(value) => setMensaje(value)}
					label='Pregunta'
					rows={8}
				>
					<></>				
				</TextArea>
			}
		</SmartForm>
	)
}